class CaratorySizeSelector extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector("[data-option-selector]");
    this.previousButton = this.querySelector("[data-size-previous]");
    this.nextButton = this.querySelector("[data-size-next]");

    if (!this.track) {
      return;
    }

    this.previousButton?.addEventListener("click", () => this.selectOffset(-1));
    this.nextButton?.addEventListener("click", () => this.selectOffset(1));
    this.track.addEventListener("change", () => this.update());

    requestAnimationFrame(() => this.update(false));
  }

  get choices() {
    return Array.from(this.track.querySelectorAll('input[type="radio"]')).map((input) => ({
      input,
      label: input.nextElementSibling
    })).filter(({ label }) => label && !label.hidden);
  }

  selectOffset(offset) {
    const choices = this.choices;
    const selectedIndex = choices.findIndex(({ input }) => input.checked);
    const nextChoice = choices[selectedIndex + offset];

    if (nextChoice) {
      nextChoice.input.click();
    }
  }

  update(animate = true) {
    const choices = this.choices;
    const selectedIndex = choices.findIndex(({ input }) => input.checked);
    const isRingSelector = this.dataset.kind === "ring";

    choices.forEach(({ label }, index) => {
      const distance = Math.abs(index - selectedIndex);
      if (isRingSelector) {
        label.dataset.distance = String(Math.min(distance, 3));
      } else {
        delete label.dataset.distance;
      }
      label.classList.toggle("is-current", index === selectedIndex);
    });

    if (this.previousButton) {
      this.previousButton.disabled = selectedIndex <= 0;
    }

    if (this.nextButton) {
      this.nextButton.disabled = selectedIndex === -1 || selectedIndex >= choices.length - 1;
    }

    const selectedLabel = choices[selectedIndex]?.label;

    if (selectedLabel && isRingSelector) {
      const left = selectedLabel.offsetLeft - (this.track.clientWidth - selectedLabel.offsetWidth) / 2;
      this.track.scrollTo({
        left: Math.max(0, left),
        behavior: animate && !window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "smooth" : "auto"
      });
    }
  }
}

if (!window.customElements.get("caratory-size-selector")) {
  window.customElements.define("caratory-size-selector", CaratorySizeSelector);
}
